import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API service for RAILS by DX
export const railsAPI = {
  // Join community
  joinCommunity: async (data) => {
    try {
      const response = await axios.post(`${API}/community/join`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to join community. Please try again.';
    }
  },

  // Sign up for sessions
  signUpForSession: async (email) => {
    try {
      const response = await axios.post(`${API}/sessions/signup`, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Failed to sign up. Please try again.';
    }
  },

  // Get stats
  getStats: async () => {
    try {
      const response = await axios.get(`${API}/stats`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch stats:', error);
      // Return default stats on error
      return {
        active_members: 1000,
        projects_done: 25,
        training_sessions: 50,
        tools_covered: 100,
        industry_sectors: 20
      };
    }
  },

  // Get member count
  getMemberCount: async () => {
    try {
      const response = await axios.get(`${API}/community/members/count`);
      return response.data.count;
    } catch (error) {
      console.error('Failed to fetch member count:', error);
      return 0;
    }
  },

  // Get session signup count
  getSessionSignupCount: async () => {
    try {
      const response = await axios.get(`${API}/sessions/signups/count`);
      return response.data.count;
    } catch (error) {
      console.error('Failed to fetch signup count:', error);
      return 0;
    }
  },

  // Get email logs
  getEmailLogs: async () => {
    try {
      const response = await axios.get(`${API}/admin/email-logs`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch email logs:', error);
      return [];
    }
  },

  // Get all members (admin)
  getAllMembers: async () => {
    try {
      const response = await axios.get(`${API}/admin/members`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch members:', error);
      return [];
    }
  },

  // Get all signups (admin)
  getAllSignups: async () => {
    try {
      const response = await axios.get(`${API}/admin/signups`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch signups:', error);
      return [];
    }
  },

  // Health check
  healthCheck: async () => {
    try {
      const response = await axios.get(`${API}/health`);
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      return { status: 'unhealthy' };
    }
  }
};
